import React from 'react';

import {
    default as comisionesApi,
    SERVICE_COMISIONES_APV,
    SERVICE_COMISIONES_FP
} from '../../api/v2/comisiones';

export const TipoComision = {
    APV: 'APV',
    FP: 'FP'
};

class TablaComision extends React.Component {
    state = {
        data: [],
    };

    componentDidMount() {
        this.fetchData();
    }

    fetchData = async () => {
        try {
            const { tipoComision } = this.props;
            if (tipoComision === TipoComision.APV) {
                let response = await comisionesApi.get(SERVICE_COMISIONES_APV);
                let { data } = response;
                this.setState({ data });
                return;
            } else if (tipoComision === TipoComision.FP) {
                let response = await comisionesApi.get(SERVICE_COMISIONES_FP);
                let { data } = response;
                this.setState({ data });
                return;
            }

            return;
        } catch (error) {
            console.log('Error', error);
            return null;
        }
    }

    renderTableAPV = (data) => {
        return (
            <div className="table">
                <table>
                    <thead>
                        <tr>
                            <th>Tipo de fondo</th>
                            <th align="right">Afiliados/No Afiliados</th>

                        </tr>
                    </thead>
                    <tbody>
                        {
                            (data && data.length > 0) && data.map(({ type, affiliates }, idx) => (
                                <tr key={`tr-${idx}`}>
                                    <td>{type}</td>
                                    <td align="right">{(affiliates * 1).toFixed(2)}%</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        );
    }

    renderTableFP = (data) => {
        return (
            <div className="table">
                <table>
                    <thead>
                        <tr>
                            <th>Tipo de fondo</th>
                            <th align="right">Afiliados Mensual</th>
                            <th align="right">No Afiliados Mensual</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            (data && data.length > 0) && data.map(({ type, affiliates, unaffiliated }, idx) => (
                                <tr key={`tr-${idx}`}>
                                    <td>{type}</td>
                                    <td align="right">{(affiliates * 1).toFixed(2)}%</td>
                                    <td align="right">{(unaffiliated * 1).toFixed(2)}%</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        const { data } = this.state;
        const { tipoComision } = this.props;

        if (tipoComision === TipoComision.APV) {
            return this.renderTableAPV(data);
        }
        if (tipoComision === TipoComision.FP) {
            return this.renderTableFP(data);
        }

        return null;
    }
}

export default TablaComision;
